module.exports = __webpack_public_path__ + "img/ched-logo-nstp.ebe10729.png";